import { useNavigate, useSearch } from '@tanstack/react-router'
import { Page } from '../../components/layout/AppShell'
import { PageHeader } from '../../components/layout/PageHeader'
import { Tabs, type TabDef } from '../../components/ui'
import { EventsTab } from './EventsTab'
import { AgentsTab } from './AgentsTab'
import { RunsTab } from './RunsTab'
import { CronsTab } from './CronsTab'
import { LedgerTab } from './LedgerTab'
import { LoopsTab } from './LoopsTab'
import { PersonalSkillsTab } from '../skills/PersonalSkillsPage'

type Tab = 'events' | 'agents' | 'runs' | 'schedule' | 'ledger' | 'loops' | 'skills'
const TABS: TabDef<Tab>[] = [
  { key: 'agents', label: 'Agents' },
  { key: 'events', label: 'Event log' },
  { key: 'runs', label: 'Agent runs' },
  { key: 'schedule', label: 'Schedule' },
  { key: 'ledger', label: 'Ledger' },
  { key: 'loops', label: 'Loops' },
  { key: 'skills', label: 'Skills' },
]

export function AgentsPage() {
  const navigate = useNavigate()
  const search = useSearch({ from: '/app/agents' }) as { tab?: Tab }
  const tab: Tab =
    search.tab === 'events' ||
    search.tab === 'runs' ||
    search.tab === 'schedule' ||
    search.tab === 'ledger' ||
    search.tab === 'loops' ||
    search.tab === 'skills'
      ? search.tab
      : 'agents'

  return (
    <Page
      header={<PageHeader crumbs={[{ label: 'Agents' }]} />}
      tabs={
        <Tabs<Tab>
          tabs={TABS}
          active={tab}
          onChange={(t) => navigate({ to: '/agents', search: { tab: t }, replace: true })}
        />
      }
    >
      {tab === 'events' && <EventsTab active={tab === 'events'} />}
      {tab === 'agents' && <AgentsTab active={tab === 'agents'} />}
      {tab === 'runs' && <RunsTab active={tab === 'runs'} />}
      {tab === 'schedule' && <CronsTab active={tab === 'schedule'} />}
      {tab === 'ledger' && <LedgerTab active={tab === 'ledger'} />}
      {tab === 'loops' && <LoopsTab active={tab === 'loops'} />}
      {tab === 'skills' && <PersonalSkillsTab active={tab === 'skills'} />}
    </Page>
  )
}
